import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/Discarded-Clean-Circle-Transparent.png';
import { BasketContext } from '../contexts/BasketContext';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const NavBar = () => {
    const { basketCount, calculateTotal } = useContext(BasketContext);
    const location = useLocation();
    const isHomePage = location.pathname === '/';
    const [navbarStyle, setNavbarStyle] = useState({
    backgroundColor: isHomePage ? 'rgba(0, 0, 0, 0)' : 'rgba(0, 0, 0, 1)',
    borderBottom: isHomePage ? '2px solid transparent' : '2px solid #ffffff',
    transition: 'background-color 0.5s ease, border-color 0.5s ease',
    });

    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const isHomePage = location.pathname === '/';

        const SOLID = {
            backgroundColor: 'rgba(0, 0, 0, 1)',
            borderBottom: '2px solid #c4a96a',
            transition: 'background-color 0.5s ease, border-color 0.5s ease',
        };
        const TRANSPARENT = {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderBottom: '2px solid transparent',
            transition: 'background-color 0.5s ease, border-color 0.5s ease',
        };

        if (!isHomePage) {
            setNavbarStyle(SOLID);
            return;
        }

        // Measure the header once instead of calling getBoundingClientRect on
        // every scroll event - reading layout mid-scroll forces the browser to
        // flush pending layout work, which is what made fast scrolling stutter.
        let headerHeight = document.querySelector('.home-header')?.offsetHeight || window.innerHeight;
        let rafId = null;
        // Track the current state so we only call setNavbarStyle when the value
        // actually flips, rather than on every single scroll event.
        let isSolid = null;

        const applyStyle = () => {
            rafId = null;
            const nextSolid = window.scrollY >= headerHeight;
            if (nextSolid === isSolid) return;
            isSolid = nextSolid;
            setNavbarStyle(nextSolid ? SOLID : TRANSPARENT);
        };

        const onScroll = () => {
            if (rafId !== null) return;
            rafId = window.requestAnimationFrame(applyStyle);
        };

        const onResize = () => {
            headerHeight = document.querySelector('.home-header')?.offsetHeight || window.innerHeight;
            applyStyle();
        };

        applyStyle();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onResize);
            if (rafId !== null) window.cancelAnimationFrame(rafId);
        };
    }, [location.pathname]);
    

    useEffect(() => {
        // Close the menu on route changes
        setMenuOpen(false);
    }, [location.pathname]);

    const handleMenuClick = () => {
        setMenuOpen(!menuOpen);
    };

    const handleLinkClick = () => {
        setMenuOpen(false); // Close the menu explicitly
    };

    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    zIndex: 998,
                    visibility: menuOpen ? 'visible' : 'hidden',
                    opacity: menuOpen ? 1 : 0,
                    backdropFilter: menuOpen ? 'blur(4px)' : 'none',
                    transition: 'opacity 0.3s ease, visibility 0.3s ease',
                }}
                onClick={handleLinkClick}
            ></div>

            <nav
                className="navbar navbar-expand-lg navbar-dark fixed-top custom-navbar"
                style={navbarStyle}
            >
                <div className="container-fluid d-flex align-items-center position-relative">
                    <Link className="navbar-brand custom-logo-container" to="/">
                        <img src={logo} alt="Logo" className="img-fluid custom-logo" />
                    </Link>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded={menuOpen}
                        aria-label="Toggle navigation"
                        onClick={handleMenuClick}
                        style={{ marginLeft: 'auto' }}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`} id="navbarNav">
                        <ul
                            className="navbar-nav text-center custom-navbar-links"
                            style={{
                                position: 'absolute',
                                left: '50%',
                                transform: 'translateX(-50%)',
                            }}
                            >
                        <li className="nav-item">
                                <Link
                                    to="/shows"
                                    className="nav-link text-white custom-nav-link"
                                    onClick={handleLinkClick}
                                >
                                    Shows
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    to="/releases"
                                    className="nav-link text-white custom-nav-link"
                                    onClick={handleLinkClick}
                                >
                                    Releases
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    to="/gallery"
                                    className="nav-link text-white custom-nav-link"
                                    onClick={handleLinkClick}
                                >
                                    Gallery
                                </Link>
                            </li>
                            {/* <li className="nav-item">
                                <Link
                                    to="/products"
                                    className="nav-link text-white custom-nav-link"
                                    onClick={handleLinkClick}
                                >
                                    Products
                                </Link>
                            </li> */}
                            <li className="nav-item">
                                <Link
                                    to="/about-us"
                                    className="nav-link text-white custom-nav-link"
                                    onClick={handleLinkClick}
                                >
                                    About Us
                                </Link>
                            </li>
                            
                            <li className="nav-item">
                                <Link
                                    to="/contact"
                                    className="nav-link text-white custom-nav-link"
                                    onClick={handleLinkClick}
                                >
                                    Contact
                                </Link>
                            </li>
                            <li className="nav-item d-lg-none custom-cart-container">
                            {/* <Link to="/basket" className="nav-link text-white d-flex align-items-center">
        <i className="bi bi-cart-fill" style={{ fontSize: '2rem', marginRight: '0.5rem' }}></i>
        <span className="cart-details">
            {basketCount} / €{calculateTotal().toFixed(2)}
        </span>
    </Link> */}
                            </li>
                        </ul>
                    </div>

                    {/* <div className="d-none d-lg-flex align-items-center custom-cart-container">
                        <Link to="/basket" className="nav-link text-white d-flex align-items-center">
                            <i className="bi bi-cart-fill" style={{ fontSize: '2rem' }}></i>
                            <span className="mx-2">
                                {basketCount} / €{calculateTotal().toFixed(2)}
                            </span>
                        </Link>
                    </div> */}
                </div>
            </nav>
        </>
    );
};

export default NavBar;